<template>
  <AppLayout>
    <div class="transaction fleet-module-page">
      <section class="container">
      

        <div class="fleet-stat-grid">
          <div class="fleet-stat-card"><span>Total Requests</span><strong>{{ fuelStats?.total || 0 }}</strong></div>
          <div class="fleet-stat-card"><span>Pending</span><strong>{{ fuelStats?.pending || 0 }}</strong></div>
          <div class="fleet-stat-card"><span>Approved</span><strong>{{ fuelStats?.approved || 0 }}</strong></div>
          <div class="fleet-stat-card"><span>Total Cost</span><strong>{{ formatCompactCurrency(fuelStats?.totalCost || 0) }}</strong></div>
        </div>

        <div class="filter-search">
          <div class="filter-search-header"><p>Filter</p></div>
          <div class="filter-search-content">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Search</label>
                  <input v-model="filters.search" class="form-control" placeholder="Vehicle, requester or project..." />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Status</label>
                  <select v-model="filters.status" class="form-control">
                    <option value="">All</option>
                    <option value="PENDING">Pending</option>
                    <option value="APPROVED">Approved</option>
                    <option value="REJECTED">Rejected</option>
                    <option value="ALLOCATED">Allocated</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Vehicle</label>
                  <select v-model="filters.vehicleId" class="form-control">
                    <option value="">All Vehicles</option>
                    <option v-for="v in vehicles" :key="v.id" :value="String(v.id)">{{ v.plateNumber }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

         <div class="table-toolbar">
            <div class="table-toolbar-actions">
              <button class="btn btn-style-2 btn-sm" @click="openCreateModal">Add Fuel Request</button>
            </div>
          </div>
        <div class="data-table-wrapper">
         
          <div class="table-wrap">
            <table ref="fleetTable" class="fleet-table table table-hover">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Vehicle</th>
                  <th>Project</th>
                  <th>Requester</th>
                  <th>Litres</th>
                  <th>Total Cost</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(f, index) in filteredFuels" :key="f.id || f.fuel_entry_id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ f?.vehicle?.plateNumber || f.vehicle_id || '-' }}</td>
                  <td>{{ getProjectName(f) }}</td>
                  <td>{{ f?.user?.name || '-' }}</td>
                  <td>{{ f.requested_litres ?? f.requestedLitres ?? '-' }}</td>
                  <td>{{ formatCurrency(getFuelCost(f)) }}</td>
                  <td><span class="status-pill" :class="statusClass(f.status)">{{ f.status || 'UNKNOWN' }}</span></td>
                  <td>
                    <div class="table-actions">
                      <RouterLink class="mini-btn" :to="`/fleet/fuel/${f.id || f.fuel_entry_id}`">View</RouterLink>
                      <button class="mini-btn" @click="startEdit(f)">Edit</button>
                      <button class="mini-btn" @click="approveFuel(f)">Approve</button>
                      <button class="mini-btn" @click="openReject(f)">Reject</button>
                      <button class="mini-btn" @click="openAllocate(f)">Allocate</button>
                      <button class="mini-btn danger" @click="removeFuel(f)">Delete</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="showModal" class="svc-modal-overlay" @click.self="closeModal">
          <div class="svc-modal-box">
            <div class="svc-modal-header">
              <h6 class="fw-bold mb-0">{{ editId ? 'Edit Fuel Request' : 'Add Fuel Request' }}</h6>
              <button class="btn-close-plain" @click="closeModal">&times;</button>
            </div>
            <div class="svc-modal-body">
              <div class="row g-2">
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">Vehicle</label>
                  <select v-model.number="form.vehicle_id" class="form-control form-control-sm">
                    <option :value="null">Select vehicle</option>
                    <option v-for="v in vehicles" :key="v.id" :value="v.id">{{ v.plateNumber }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">Project</label>
                  <select v-if="projects.length" v-model.number="form.project_id" class="form-control form-control-sm">
                    <option :value="null">Select project</option>
                    <option v-for="p in projects" :key="p.id" :value="p.id">{{ p.projectName || p.name }}</option>
                  </select>
                  <input v-else v-model.number="form.project_id" type="number" class="form-control form-control-sm" placeholder="Project ID" />
                </div>
                <div class="col-md-4">
                  <label class="form-label" style="font-size:11px;">Requested Litres</label>
                  <input v-model.number="form.requested_litres" type="number" min="1" class="form-control form-control-sm" />
                </div>
                <div class="col-md-4">
                  <label class="form-label" style="font-size:11px;">Cost per Litre</label>
                  <input v-model.number="form.costPerLitre" type="number" min="0" class="form-control form-control-sm" />
                </div>
                <div class="col-md-4">
                  <label class="form-label" style="font-size:11px;">Odometer Reading</label>
                  <input v-model.number="form.odometerReading" type="number" min="0" class="form-control form-control-sm" />
                </div>
              </div>
              <p v-if="errorMessage" class="text-danger small mt-2">{{ errorMessage }}</p>
            </div>
            <div class="svc-modal-footer">
              <button class="btn btn-sm btn-style-2" @click="closeModal">Cancel</button>
              <button class="btn btn-sm btn-primary" @click="saveFuel" :disabled="saving">
                <span v-if="saving"><i class="fas fa-spinner fa-spin me-1"></i>Saving...</span>
                <span v-else>Save Request</span>
              </button>
            </div>
          </div>
        </div>

        <div v-if="actionMode" class="svc-modal-overlay" @click.self="clearAction">
          <div class="svc-modal-box" style="max-width: 560px;">
            <div class="svc-modal-header">
              <h6 class="fw-bold mb-0">{{ actionMode === 'reject' ? 'Reject Fuel Request' : 'Allocate Fuel Request' }}</h6>
              <button class="btn-close-plain" @click="clearAction">&times;</button>
            </div>
            <div class="svc-modal-body">
              <div v-if="actionMode === 'reject'" class="row g-2">
                <div class="col-12">
                  <label class="form-label" style="font-size:11px;">Reason</label>
                  <textarea v-model="actionForm.reason" class="form-control form-control-sm" rows="4"></textarea>
                </div>
              </div>
              <div v-else class="row g-2">
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">Actual Litres</label>
                  <input v-model.number="actionForm.actualLitres" type="number" min="0" class="form-control form-control-sm" />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">Allocation Notes</label>
                  <input v-model="actionForm.allocationNotes" class="form-control form-control-sm" />
                </div>
              </div>
            </div>
            <div class="svc-modal-footer">
              <button class="btn btn-sm btn-style-2" @click="clearAction">Cancel</button>
              <button class="btn btn-sm btn-primary" @click="submitAction" :disabled="saving">
                <span v-if="saving"><i class="fas fa-spinner fa-spin me-1"></i>Submitting...</span>
                <span v-else>Submit</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from '@/components/AppLayout.vue';
import fleetApi from '@/api/fleet';
import Swal from '@/utils/swal';
import 'datatables.net-vue3';
import 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-responsive-bs5';
import $ from 'jquery';
import 'jszip';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.print.js';

function emptyForm() {
  return {
    vehicle_id: null,
    project_id: null,
    requested_litres: null,
    costPerLitre: null,
    odometerReading: null,
  };
}

export default {
  name: 'FleetFuel',
  components: { AppLayout },
  data() {
    return {
      fuels: [],
      vehicles: [],
      projects: [],
      dataTable: null,
      showModal: false,
      editId: null,
      saving: false,
      errorMessage: '',
      filters: {
        search: '',
        status: '',
        vehicleId: '',
      },
      form: emptyForm(),
      actionMode: '',
      actionTarget: null,
      actionForm: {
        reason: '',
        actualLitres: null,
        allocationNotes: '',
      },
    };
  },
  computed: {
    filteredFuels() {
      const q = String(this.filters.search || '').toLowerCase().trim();
      return (this.fuels || []).filter((f) => {
        const text = [f?.vehicle?.plateNumber, f?.user?.name, this.getProjectName(f), f.status].filter(Boolean).join(' ').toLowerCase();
        const matchesSearch = !q || text.includes(q);
        const matchesStatus = !this.filters.status || String(f.status || '').toUpperCase() === this.filters.status;
        const matchesVehicle = !this.filters.vehicleId || String(f?.vehicle?.id || f.vehicle_id || f.vehicleId) === String(this.filters.vehicleId);
        return matchesSearch && matchesStatus && matchesVehicle;
      });
    },
    fuelStats() {
      const items = Array.isArray(this.fuels) ? this.fuels : [];
      const pending = items.filter((f) => String(f.status || '').toUpperCase() === 'PENDING').length;
      const approved = items.filter((f) => ['APPROVED', 'ALLOCATED'].includes(String(f.status || '').toUpperCase())).length;
      const totalCost = items.reduce((sum, f) => sum + this.getFuelCost(f), 0);
      return { total: items.length, pending, approved, totalCost };
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.initializeDataTable();
      },
    },
  },
  methods: {
    destroyDataTable() {
      if (this.dataTable && typeof this.dataTable.destroy === 'function') {
        this.dataTable.destroy();
        this.dataTable = null;
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        const tableElement = this.$refs.fleetTable;
        if (!tableElement) return;
        this.destroyDataTable();
        this.dataTable = $(tableElement).DataTable({
          responsive: true,
          destroy: true,
          pageLength: 10,
          lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, 'All']],
          language: {
            emptyTable: 'No fuel requests found',
            paginate: {
              previous: '<i class="fa fa-chevron-left"></i>',
              next: '<i class="fa fa-chevron-right"></i>',
            },
          },
          dom: 'Bfrtip',
          buttons: [
            'colvis',
            'pageLength',
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-sm btn-outline-primary',
              exportOptions: { columns: ':visible' },
            },
          ],
        });
      });
    },
    notifyError(err) {
      this.$toast?.error?.(err?.message || 'Request failed');
    },
    formatCurrency(v) {
      if (v === null || v === undefined || Number.isNaN(Number(v))) return '-';
      return new Intl.NumberFormat('en-KE', { style: 'currency', currency: 'KES' }).format(Number(v));
    },
    formatCompactCurrency(v) {
      if (!v) return 'KES 0';
      return `KES ${new Intl.NumberFormat().format(Math.round(v))}`;
    },
    getFuelCost(f) {
      const direct = Number(f.totalCost ?? f.total_cost);
      if (!Number.isNaN(direct) && direct) return direct;
      return Number(f.requested_litres ?? f.requestedLitres ?? 0) * Number(f.costPerLitre ?? 0);
    },
    getProjectName(f) {
      return f?.project?.projectName || f?.project?.name || (f.project_id ? `Project ${f.project_id}` : '-');
    },
    statusClass(status) {
      const value = String(status || '').toLowerCase();
      if (value === 'approved' || value === 'allocated') return 'status-approved';
      if (value === 'pending') return 'status-pending';
      if (value === 'rejected') return 'status-rejected';
      return 'status-default';
    },
    async loadProjects() {
      try {
        const raw = localStorage.getItem('access_token');
        const token = raw ? JSON.parse(raw) : null;
        const res = await fetch((process.env.VUE_APP_URL || '') + '/projects', {
          headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        });
        const data = await res.json();
        this.projects = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
      } catch {
        this.projects = [];
      }
    },
    async loadFuels() {
      try {
        const [fuelsRes, vehiclesRes] = await Promise.all([
          fleetApi.listFuels({ page: 1, limit: 200 }),
          fleetApi.listVehicles({ page: 1, limit: 200 }),
          this.loadProjects(),
        ]);
        this.fuels = fleetApi.unwrapList(fuelsRes);
        this.vehicles = fleetApi.unwrapList(vehiclesRes);
        this.initializeDataTable();
      } catch (err) {
        this.notifyError(err);
      }
    },
    openCreateModal() {
      this.editId = null;
      this.form = emptyForm();
      this.errorMessage = '';
      this.showModal = true;
    },
    startEdit(f) {
      this.editId = f.id || f.fuel_entry_id;
      this.form = {
        vehicle_id: f.vehicle_id || f.vehicleId || f?.vehicle?.id || null,
        project_id: f.project_id || f?.project?.id || null,
        requested_litres: f.requested_litres ?? f.requestedLitres ?? null,
        costPerLitre: f.costPerLitre ?? null,
        odometerReading: f.odometerReading ?? null,
      };
      this.errorMessage = '';
      this.showModal = true;
    },
    closeModal() {
      this.editId = null;
      this.form = emptyForm();
      this.showModal = false;
      this.errorMessage = '';
    },
    async saveFuel() {
      if (!this.form.vehicle_id || !this.form.project_id || !this.form.requested_litres) {
        this.errorMessage = 'Vehicle, project and requested litres are required.';
        return;
      }
      this.saving = true;
      try {
        if (this.editId) {
          await fleetApi.updateFuel(this.editId, this.form);
          this.$toast?.success?.('Fuel request updated');
        } else {
          await fleetApi.createFuel(this.form);
          this.$toast?.success?.('Fuel request created');
        }
        this.closeModal();
        await this.loadFuels();
      } catch (err) {
        this.notifyError(err);
      } finally {
        this.saving = false;
      }
    },
    async approveFuel(f) {
      const id = f.id || f.fuel_entry_id;
      if (!id) return;
      try {
        await fleetApi.approveFuel(id);
        this.$toast?.success?.('Fuel request approved');
        await this.loadFuels();
      } catch (err) {
        this.notifyError(err);
      }
    },
    openReject(f) {
      this.actionMode = 'reject';
      this.actionTarget = f;
      this.actionForm = { reason: '', actualLitres: null, allocationNotes: '' };
    },
    openAllocate(f) {
      this.actionMode = 'allocate';
      this.actionTarget = f;
      this.actionForm = { reason: '', actualLitres: null, allocationNotes: '' };
    },
    clearAction() {
      this.actionMode = '';
      this.actionTarget = null;
      this.actionForm = { reason: '', actualLitres: null, allocationNotes: '' };
    },
    async submitAction() {
      const id = this.actionTarget?.id || this.actionTarget?.fuel_entry_id;
      if (!id) return;
      this.saving = true;
      try {
        if (this.actionMode === 'reject') {
          if (!this.actionForm.reason) {
            this.$toast?.warning?.('Provide rejection reason');
            return;
          }
          await fleetApi.rejectFuel(id, this.actionForm.reason);
          this.$toast?.success?.('Fuel request rejected');
        } else if (this.actionMode === 'allocate') {
          await fleetApi.allocateFuel(id, {
            actualLitres: this.actionForm.actualLitres,
            allocationNotes: this.actionForm.allocationNotes,
          });
          this.$toast?.success?.('Fuel request allocated');
        }
        this.clearAction();
        await this.loadFuels();
      } catch (err) {
        this.notifyError(err);
      } finally {
        this.saving = false;
      }
    },
    async removeFuel(f) {
      const id = f.id || f.fuel_entry_id;
      if (!id) return;
      const result = await Swal.fire({
        title: 'Delete this fuel request?',
        text: 'This action cannot be undone!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      });
      if (!result.isConfirmed) return;
      try {
        await fleetApi.deleteFuel(id);
        this.$toast?.success?.('Fuel request deleted');
        await this.loadFuels();
      } catch (err) {
        this.notifyError(err);
      }
    },
  },
  mounted() {
    this.loadFuels();
  },
  beforeUnmount() {
    this.destroyDataTable();
  },
};
</script>

<style scoped>
@import './fleet.shared.css';
</style>
